import { render, staticRenderFns } from "./StudioHomeTemplateModern.vue?vue&type=template&id=540e9274&scoped=true&"
import script from "./StudioHomeTemplateModern.vue?vue&type=script&lang=js&"
export * from "./StudioHomeTemplateModern.vue?vue&type=script&lang=js&"
import style0 from "./StudioHomeTemplateModern.vue?vue&type=style&index=0&id=540e9274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540e9274",
  null
  
)

export default component.exports